import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';
import { HistoryOutlined as HistoryOutlinedIcon } from '@mui/icons-material';
import { ArrowDropDownIcon } from '@mui/x-date-pickers-pro';

const VisitLogs = ({ Logs, visitsLogsTitleStr, visitsLogsEmptyStr }) => {
  return (
    <Box flex={6} mx={2}>
      {/* <Typography fontWeight='bold'>{visitsLogsTitleStr}</Typography> */}
      <Box className='visitLogsContainer' height='100%'>
        <Box className='visitLogsList' height='100%' sx={{ overflowY: 'auto' }}>
          {Object.keys(Logs).length !== 0 ? (
            Object.entries(Logs).map(([date, logs], index) => {
              const formattedDate = moment(date, 'YYYY-MM-DD')
                .locale('es')
                .format('[Día] D [de] MMMM [del] YYYY');

              return (
                <Accordion
                  className='visitLogsAccordion'
                  key={date}
                  defaultExpanded={index === 0}
                >
                  <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      {formattedDate}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box>
                      {logs.map((log, index) => (
                        <Box key={index}>
                          <Typography component='span' fontWeight='bold'>
                            {log.time}
                          </Typography>
                          <Typography component='span'>{` - ${log.reason}`}</Typography>
                        </Box>
                      ))}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              );
            })
          ) : (
            <Box
              display='flex'
              alignItems='center'
              justifyContent='center'
              flexDirection='column'
              minHeight='10vh'
              height='100%'
              width='100%'
            >
              <HistoryOutlinedIcon color='disabled' sx={{ fontSize: '3rem' }} />
              <Typography color='gray'>{visitsLogsEmptyStr}</Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default VisitLogs;
